import { IConfigsType } from '../../types'

const originalCorporatePagesConfig: IConfigsType = {
  irmg_bk: {
    '/:brand/systemwide_overview': {},
  },
}

export default originalCorporatePagesConfig
